import styled from 'styled-components';

import {CheckBox} from '../../common/CheckBox/CheckBox';

// HOVER STUFF

export const HiddenDropdownWrapperDiv = styled.div`
  height: 40rem;
  overflow-y: scroll;
  width: ${props => props.width || '23rem'};
  max-width: 30rem;
  z-index: ${props => props.theme.misc.zIndex.base};
  visibility: visible;
  transition: opacity 0.8s;
  padding: ${props => props.theme.spacing.base} 0;
  position: absolute;
  top: ${props => props.top || '3rem'};
  left: 3rem;
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const HoverTargetWrapperDiv = styled.div`
  position: relative;
  text-align: left;
  display: inline-flex;
  align-self: flex-start;
  /* &:hover > ${HiddenDropdownWrapperDiv} {
    visibility: visible;
  } */
`;

export const TopDiv = styled.div`
  background-color: ${props => props.theme.colors.goWhite.base};
  border-radius: ${props => props.theme.misc.borderRadius.base};
  box-shadow: 0 ${props => props.theme.spacing.xxsmall} ${props => props.theme.spacing.custom(4)}
    ${props => props.theme.colors.shadow.base};
`;

const TipUI = styled.div`
  position: absolute;
  margin-left: -${props => props.theme.spacing.base};
  width: 2.4rem;
  height: 1.2rem;
  overflow: hidden;
  &::after {
    content: '';
    position: absolute;
    width: 1.3rem;
    height: 1.2rem;
    left: 50%;
  }
`;

export const TipPositioning = styled(TipUI)(
  props => `
  left: 15%;
  top: -0.1rem;
  &::after {
    transform: translate(-50%, 50%) rotate(45deg);
    background-color: ${props.theme.colors.goWhite.base};
    box-shadow: 0 ${props.theme.spacing.xxsmall} ${props.theme.spacing.custom(4)}
      ${props.theme.colors.shadow.base};
  }
`,
);

// CONTENT STUFF

export const WrapperDiv = styled.div<{isChecked: boolean}>(
  props => `
  border: ${props.theme.misc.border.base} solid ${props.theme.colors.goBrandBlue.light};
  padding: ${props.theme.spacing.custom(8)} ${props.theme.spacing.base};
  border-radius: ${props.theme.misc.borderRadius.xlarge};
  margin-right: ${props.theme.spacing.custom(8)};
  cursor: pointer;
  background-color: ${(props.isChecked && props.theme.colors.goBrandBlue.base) ||
    props.theme.colors.goWhite.base};
  color: ${(props.isChecked && props.theme.colors.goWhite.base) ||
    props.theme.colors.goBrandBlue.base};
  `,
);

export const StyledCheckBox = styled(CheckBox)(
  props => `
  height: 1.3rem;
  width: 1.3rem;
  margin-top: ${props.theme.spacing.custom(3)};
`,
);

export const FontBoldSpan = styled.span`
  font-weight: bold;
`;

export const FontBoldUppercasedSpan = styled.span`
  font-weight: bold;
  text-transform: uppercase;
`;

export const FontBigBold = styled.span(
  props => `
  font-size: ${props.theme.font.custom(14)};
`,
);

export const WrapperSpan = styled.span(
  props => `
    padding: 0 ${props.theme.spacing.small};
    // text-decoration: underline;
`,
);

export const ClearAllButton = styled.span(
  props => `
    right: 10px;
    float: right;
    position: absolute;
    font-weight: 600;
    cursor: pointer;
  `,
);

export const SortingDropDownWrapper = styled.div(
  props => `
width: 100%;
display: flex;
list-style-type: none;
overflow: hidden;
padding: ${props.theme.spacing.small} 0 0;
flex-direction: column;
border: 0.1rem solid ${props.theme.colors.goBrandBlue.light};
border-top:none;
> li {
  width: 100%;
  display: flex;
  flex-direction: row;
  border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
  padding: ${props.theme.spacing.base};
  position: relative;
  &:last-child {
    border-bottom: none;
  }
}
`,
);

export const RadioCheck = styled.input.attrs({type: 'radio'})(
  props => `
  width: 1.7rem;
  height: 2rem;
  align-items: center;
  justify-content: center;
  margin-right: ${props.theme.spacing.small};
  border-radius: 50%;
  display: inline-block;
  cursor: pointer;
  //margin-top: ${props.theme.spacing.custom(3)};
  &:checked{
      background-color: #e9ecee;
      border: 2px solid #adb8c0;
      color: #99a1a7;
      // padding: ${props.theme.spacing.base};
  }
  :checked:after {
      background-color: ${props.theme.colors.goBrandBlue.base};
      border-radius: 5rem;
      box-shadow: 0 0 0px 2px rgba(255,255,255,1) inset;
      content: " ";
      height: 1.4rem;
      position: absolute;
      width: 1.4rem;
      top: 1rem;
      left: 1rem;
      border: 0.2rem solid ${props.theme.colors.goBrandBlue.base};
  }
`,
);

export const QuickFiltersSticky = styled.div(
  props => `
  position:sticky;
  top:-1rem;
  background:${props.theme.colors.goWhite.base};
  padding:${props.theme.spacing.large};
  z-index:${props.theme.misc.zIndex.xxsmall};
  border-bottom: 0.1rem solid ${props.theme.colors.goBrandBlue.light};

  `,
);
